import { CircleX, Info } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ERROR } from '@/utils/constants';
import { Icon } from '@/utils/types';

type Variant = 'default' | 'destructive';

interface Props {
  className?: string;
  description?: string;
  title?: string;
  variant?: Variant;
}

const icons: Record<Variant, Icon> = {
  default: Info,
  destructive: CircleX,
};

export default function AppMessage({
  className = '',
  description = ERROR.GENERIC,
  title = 'Error',
  variant = 'destructive',
}: Props) {
  const IconComponent = icons[variant];

  return (
    <Alert className={className} variant={variant}>
      <IconComponent aria-hidden="true" className="size-4" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
}
